import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import chat from './modules/chat'
import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    user,
    chat,
  },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js